import React from 'react'
import axios from 'axios'

import Diagram from 'images/upload/guidelines_diagram.png'

import Icon from 'Pods/Shared/Icon/Icon'
import TutorialWidget from 'Pods/Shared/TutorialWidget/TutorialWidget'

import Layout from 'Pods/Profile/Layout/Layout'
import UploaderNav from 'Pods/Profile//Products/UploaderNav'

import FoldersStructureReviewModal from './Components/FoldersStructureReviewModal'
import BadStructureModal from './Components/BadStructureModal'
import Wizard from './Components/Wizard'

class BatchUploader extends React.Component {
  constructor() {
    super()

    this.state = {
      batchUpload: null,
      files: [],
      modalIsOpen: false,
      badStructureModalIsOpen: false,
    }

    this.onFileInputChange = this.onFileInputChange.bind(this)
    this.openModal = this.openModal.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.clearInputValue = this.clearInputValue.bind(this)
    this.closeBadStructureModal = this.closeBadStructureModal.bind(this)
  }

  componentDidMount() {
    this.cancelSource = axios.CancelToken.source()

    this.fetchBatchUpload()
  }

  fetchBatchUpload() {
    axios.post('/api/internal/batch-uploads', { cancelToken: this.cancelSource.token })
      .then((response) => this.setState({ batchUpload: response.data.data }))
      .catch(() => App.events.publish('app:notification:flash:error', 'Uh, this is awkward..'))
  }

  onFileInputChange(e) {
    const files = [...e.target.files]
    const filePathsArr = files.map(file => file.webkitRelativePath.split('/')).filter(array => array[array.length - 1] !== '.DS_Store')

    // This removes file from the array and leaves only folder names
    filePathsArr.forEach(array => array.pop())

    const arraysOfTwoOrMoreFolders = filePathsArr.filter(array => array.length > 1)

    if (arraysOfTwoOrMoreFolders.length >= 1 && filePathsArr.length !== 0) {
      this.setState({ files, modalIsOpen: true })
    } else {
      this.clearInputValue()

      this.setState({ files: [], badStructureModalIsOpen: true })
    }
  }

  openModal() {
    this.setState({ modalIsOpen: true })
  }

  closeModal() {
    this.clearInputValue()

    this.setState({ files: [], modalIsOpen: false })
  }

  clearInputValue() {
    this.refs.input.value = ''
  }

  closeBadStructureModal() {
    this.setState({ badStructureModalIsOpen: false })
  }

  render() {
    return (
      <Layout activeBreadcrumb="Batch Upload" hideUploadButton>
        <TutorialWidget videoId="peNAjpb-J8E" />
        <UploaderNav />
        <Wizard />

        <div className="batch-upload">
          <div className="row">
            <div className="col-12 col-md-7">
              <div className="button-upload button-upload--drop-area">
                <div className="dropzone-container">
                  <div className="drop-area text-default">
                    <div className="drop-area__text">
                      Drag & Drop your batch folder
                      or <span className="link--primary-dark">Browse</span>
                    </div>
                    <Icon type={['fas', 'cloud-upload']} color="grey-light" />
                    <input
                      name="fileList"
                      type="file"
                      className="file-upload--full"
                      directory="directory"
                      webkitdirectory="webkitdirectory"
                      multiple
                      onChange={this.onFileInputChange}
                      onClick={this.clearInputValue}
                      ref="input"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-5 text-default upload__guidelines">
              <h1 className="section__title">Uploading guidelines</h1>
              <p>Models must be placed into their respective folders. Please follow this structure:</p>
              <div className="guidelines__image-container">
                <img src={Diagram} alt="guidelines diagram" />
              </div>
              <p>A single model and all of its related files (format files, textures, preview images) should be in a dedicated folder.</p>
              <div className="list-heading">Requirements and recommendations:</div>
              <ul className="list">
                <li>all models should have preview images and 3D model format files</li>
                <li>all textures must be archived – otherwise they will show up as preview images</li>
                <li>a single file size cannot exceed 5.5 GB</li>
                <li>archive large files for a smoother upload experience</li>
                <li>use the Latin alphabet for file names</li>
                <li>uploaded models show up as drafts – you can come back and edit or publish any model whenever you want</li>
              </ul>
              <p className="u-mt10 u-mb0">
                <Icon type={['far', 'exclamation-circle']} />
                Please note that the Batch uploader only works with Webkit-based browsers.
                Visit <a href="https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/webkitdirectory#Browser_compatibility" target="_blank">this page</a> for
                more information.
              </p>
            </div>
          </div>
        </div>
        {this.state.files.length > 0 && this.state.batchUpload
          && (
          <FoldersStructureReviewModal
            batchUploadId={this.state.batchUpload.id}
            files={this.state.files}
            imageExtensions={this.state.batchUpload.attributes.imageExtensions}
            fileExtensions={this.state.batchUpload.attributes.fileExtensions}
            modalIsOpen={this.state.modalIsOpen}
            closeModal={this.closeModal}
          />
          )
        }
        <BadStructureModal
          modalIsOpen={this.state.badStructureModalIsOpen}
          closeModal={this.closeBadStructureModal}
        />
      </Layout>
    )
  }
}

export default BatchUploader
